import { SessionStateEnum } from "../orchestrator-api-client";
import {
  AppRoutes,
  DataCollectionRoutes,
  InsuranceRoutes,
  NegotiationRoutes,
  IncomeDocumentationRoutes,
  KycRoutes,
} from "../enums/app-routes.ts";

const NavigationMapper: {
  [key in SessionStateEnum]: string;
} = {
  // TO BE REMOVED:
  [SessionStateEnum.Init]: "",
  [SessionStateEnum.ConfirmOffer]: "",
  [SessionStateEnum.RevertCpi]: "",
  // Generale
  // Da utilizzare durante elaborazioni asincrone/sincrone del WF. (Mostra un loader)
  [SessionStateEnum.Pending]: "",
  // Data Collection
  [SessionStateEnum.Privacy]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.PRIVACY_CONSENTS}`,
  [SessionStateEnum.Personal]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.PERSONAL_INFO}`,
  [SessionStateEnum.Birth]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.BIRTH}`,
  [SessionStateEnum.FiscalCode]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.FISCAL_CODE}`,
  [SessionStateEnum.Employment]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.EMPLOYMENT}`,
  [SessionStateEnum.VatNumber]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.VAT_NUMBER}`,
  [SessionStateEnum.GrossIncome]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.GROSS_INCOME}`,
  [SessionStateEnum.SelfOtherIncome]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.SELF_OTHER_INCOME}`,
  [SessionStateEnum.PensionerIncome]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.PENSIONER_INCOME}`,
  [SessionStateEnum.PensionerOtherIncome]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.PENSIONER_OTHER_INCOME}`,
  [SessionStateEnum.UnemplyedOtherIncome]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.OTHER_INCOME_SOURCES}`,
  [SessionStateEnum.Hiring]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.HIRING}`,
  [SessionStateEnum.CompanyIndustry]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.COMPANY_INDUSTRY}`,
  [SessionStateEnum.CompanySize]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.COMPANY_SIZE}`,
  [SessionStateEnum.Income]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.MONTHLY_INCOME}`,
  [SessionStateEnum.OtherIncome]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.OTHER_INCOME_SOURCES}`,
  [SessionStateEnum.Address]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.ADDRESS}`,
  [SessionStateEnum.Marital]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.MARITAL_STATUS}`,
  [SessionStateEnum.Family]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.FAMILY}`,
  [SessionStateEnum.Living]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.LIVING_SITUATION}`,
  [SessionStateEnum.Coupon]: `/${AppRoutes.DATA_COLLECTION}/${DataCollectionRoutes.COUPON_CODE}`,
  //Prestiti Online
  [SessionStateEnum.Pcw]: `/${AppRoutes.POL}`,
  // Negotiation
  [SessionStateEnum.DataCollectionCompleted]: `/${AppRoutes.NEGOTIATION}`,
  [SessionStateEnum.Cpi]: `/${AppRoutes.INSURANCE}`,
  [SessionStateEnum.Offer]: `/${AppRoutes.NEGOTIATION}/${NegotiationRoutes.OFFER}`,
  [SessionStateEnum.CpiQuestionnaire]: `/${AppRoutes.INSURANCE}/${InsuranceRoutes.QUESTIONNAIRE}`,
  [SessionStateEnum.CpiBeneficiary]: `/${AppRoutes.INSURANCE}/${InsuranceRoutes.BENEFICIARY}`,
  [SessionStateEnum.Iban]: `/${AppRoutes.NEGOTIATION}/${NegotiationRoutes.IBAN}`,
  [SessionStateEnum.DeclinedByRules]: `/${AppRoutes.NEGOTIATION}/${NegotiationRoutes.DECLINED_BY_RULES}`,
  [SessionStateEnum.BureauKo]: `/${AppRoutes.NEGOTIATION}/${NegotiationRoutes.BUREAU_KO}`,
  [SessionStateEnum.OfferKo]: "", //TODO: Waiting UX or business requirement
  // Income Documentation
  [SessionStateEnum.Payroll]: `/${AppRoutes.INCOME_DOCUMENATION}/${IncomeDocumentationRoutes.PAYROLL}`,
  [SessionStateEnum.AccountStatement]: `/${AppRoutes.INCOME_DOCUMENATION}/${IncomeDocumentationRoutes.ACCOUNT_STATEMENT}`,
  // ADV
  [SessionStateEnum.Adv]: `/${AppRoutes.ADV}`,
  // KYC
  [SessionStateEnum.Identification]: `/${AppRoutes.KYC}`,
  [SessionStateEnum.IncomeDocumentationCompleted]: "",
  [SessionStateEnum.KycInProgress]: `/${AppRoutes.KYC}/${AppRoutes.IDENTIFICATION_IN_PROGRESS}`,
  [SessionStateEnum.KycFailed]: "", // ?? Dipende da UX
  [SessionStateEnum.SpidCompleted]: "",
  [SessionStateEnum.VideoSelfieCompleted]: "",
  [SessionStateEnum.KycCompleted]: `/${AppRoutes.KYC}/${KycRoutes.COMPLETED}`,
  // Bureau and Back
  [SessionStateEnum.Bureau]: "",
  [SessionStateEnum.BureauTe]: "",
  [SessionStateEnum.Back]: "",
  [SessionStateEnum.Leads]: "",
  [SessionStateEnum.NamirialNotifications]: "",
  [SessionStateEnum.RecoveryBlock]: `/${AppRoutes.RECOVERY_BLOCK}`,
  [SessionStateEnum.DeadlockFiscalCode]: `/${AppRoutes.DEADLOCK_FISCAL_CODE}`,
  [SessionStateEnum.PostApproval]: "",
  [SessionStateEnum.DeclinedByUw]: `/${AppRoutes.DECLINED_BY_UW}`,
  [SessionStateEnum.MultiDealSelected]: "",
  [SessionStateEnum.ParsecOcrCompleted]: "",
  [SessionStateEnum.ParsecOcrError]: "",
  [SessionStateEnum.QineticCallback]: "",
};
export default NavigationMapper;

export function resolvePathToState(path: string): SessionStateEnum | undefined {
  const val = Object.entries(NavigationMapper).find(
    ([, value]) => value === path,
  );
  if (!val) return undefined;
  return val[0] as SessionStateEnum;
}
